<template>
  <div class="p-2">
    <slot name="header"></slot>

    <div
      v-for="shortlist in sortedShortlists"
      :key="shortlist.id"
      class="itemitem mb-3 group p-2 -m-2 hover:bg-gray-75 rounded"
    >
      <div class="flex items-center justify-start">
        <div>
          <ShortlistForm
            class="mb-4"
            v-if="shortlistSelectedForEditing == shortlist"
            :shortlist="shortlistSelectedForEditing"
            @update="onShortlistUpdate"
            @cancel="stopEditShortlist"
          />
          <router-link
            v-else
            class="text-gray-300 text-sm group-hover:text-gray-900 mb-0"
            :to="{
              name: 'shortlistDetailsPage',
              params: { shortlistId: shortlist.id },
            }"
          >
            {{ shortlist.name }}
          </router-link>
          <p class="text-gray-200 text-xs">
            Shortlisted startups:
            <span class="text-gray-300">{{ shortlist.startups_count }}</span>
          </p>
        </div>
        <div class="opacity-0 group-hover:opacity-80 ml-8">
          <TextButton size="sm" class="mx-2" @click="showShortlist(shortlist)">
            Show
          </TextButton>
          <TextButton size="sm" @click="editShortlist(shortlist)" class="mx-2">
            Edit
          </TextButton>
          <TextButton size="sm" class="mx-2" @click="confirmRemove(shortlist)"
            >Remove</TextButton
          >
        </div>
      </div>
    </div>
    <div class="my-4">
      <ShortlistForm
        v-if="isNewShortlistFormVisible"
        :organization-id="organizationId"
        @create="onShortlistCreate"
        @cancel="closeNewShortlistForm"
      />
      <TextButton v-else size="sm" type="primary" @click="showNewShortlistForm">
        Add shortlist
      </TextButton>
    </div>
  </div>
</template>

<script>
import { computed, ref } from '@vue/composition-api'
import Checkbox from 'components/forms/Checkbox'
import ShortlistForm from './ShortlistForm.vue'
import Button from 'components/common/Button'
import TextButton from 'components/common/TextButton'
import { orderBy } from 'lodash'
import router from '@/routes'

export default {
  components: {
    Button,
    TextButton,
    Checkbox,
    ShortlistForm,
  },
  props: {
    organizationId: String,
    shortlists: Array,
  },
  setup(props, { emit, root: { $confirm } }) {
    const isNewShortlistFormVisible = ref(false)
    const showNewShortlistForm = () => {
      isNewShortlistFormVisible.value = true
    }
    const closeNewShortlistForm = () => {
      isNewShortlistFormVisible.value = false
    }

    const onShortlistCreate = () => {
      emit('create')
      closeNewShortlistForm()
    }

    const onShortlistUpdate = () => {
      emit('update')
    }

    const init = () => {
      isNewShortlistFormVisible.value = false
    }

    init()

    const sortedShortlists = computed(() => {
      return orderBy(
        props.shortlists,
        (s) => {
          return s.name.toLowerCase()
        },
        'asc',
      )
    })

    const shortlistSelectedForEditing = ref(null)
    const editShortlist = (shortlist) => {
      shortlistSelectedForEditing.value = shortlist
    }
    const stopEditShortlist = () => {
      shortlistSelectedForEditing.value = null
    }

    const confirmRemove = (shortlist) => {
      let msg = 'Are you sure you want to remove this shortlist?'
      if (props.organizationId) {
        msg += ' It would be removed for whole organization.'
      }
      $confirm(msg, 'Remove confirmation', {
        confirmButtonText: 'Remove',
      })
        .then(async () => {
          await http.postAuthed(`/startups/shortlists/${shortlist.id}/delete`)
          emit('remove', { shortlist })
        })
        .catch((err) => {
          console.warn('confirm modal closed by the user')
          console.warn(err)
        })
    }

    const showShortlist = (shortlist) => {
      router.push({
        name: 'shortlistDetailsPage',
        params: { shortlistId: shortlist.id },
      })
    }

    return {
      onShortlistCreate,
      onShortlistUpdate,

      isNewShortlistFormVisible,
      showNewShortlistForm,
      closeNewShortlistForm,

      sortedShortlists,

      editShortlist,
      stopEditShortlist,
      shortlistSelectedForEditing,

      showShortlist,

      confirmRemove,
    }
  },
}
</script>
